'use client'
import React from 'react'
import { ThemeProvider } from 'styled-components'
import { theme, helpers } from '@caffeina-siad/ui-kit/src/theme'

export default ({ children }: { children: React.ReactNode }) => (
  <ThemeProvider theme={{ ...theme, ...helpers }}>{children}</ThemeProvider>
)
